import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const HISTORY_WIRING: Wiring = {
  [EVENTS.QueryHistoryTermSelected]: [
    WIRES.queryOriginHistory,
    WIRES.empathizeElementSelected
  ],
  [EVENTS.QueryHistoryTermRemoved]: [
    WIRES.removeQueryHistoryTerm
  ],
  [EVENTS.QueryHistoryCleared]: [
    WIRES.clearQueryHistory
  ],
  [EVENTS.QueryHistoryEnabledChanged]: [
    WIRES.setEnabledQueryHistory
  ]
};
